module.exports = __webpack_public_path__ + "img/lens-paywall-background.7dbf2ef2.jpg";